import {
    $get,
    $del,
    $put,
    $post,
    $post2,
    $post3
} from "@/utils/request";

// 登录
export const login = (data) => {
    return $post("/user/check", data);
};

// 3.3.6请求用户信息
export const getUserInfo = (data) => {
    return $post("/user/getUser", data);
};

// 请求团队信息
export const getGroupList = (data) => {
    return $post("/user/queryGroupList", data);
};

// 修改用名字
export const changeUsername = (data) => {
    return $post("/user/updateNickName", data);
};

// 修改密码
export const changePassword = (data) => {
    return $post("/user/updatePwd", data);
};
// 修改密码
export const signOut = () => {
    return $post("/user/signOut");
};

// /user/updateAccount2ndAuthSetting
export const update2ndAuth = (data) => {
    return $post("/user/updateAccount2ndAuthSetting", data);
};
// 获取个人设备列表
export const getPersonalDeviceList = (data) => {
    return $post("/user/loadDrive", data);
};

// 个人设备列表修改备注
export const updateMemo = (data) => {
    return $post("/user/removeDrive", data);
};

// 个人设备列表解除绑定
export const unbindDrive = (data) => {
    return $post("/user/unbindDrive", data);
};

// 修改团队的名称
export const updateGroupName = (data) => {
    return $post("/user/updateGroupName", data);
};

// 退出团队
export const quitGroup = (data) => {
    return $post("/user/signOutGroup", data);
};

// 获取设备分组
export const getGroupAside = (data) => {
    return $post("/user/queryGroupDivideList", data);
};

// 获取所有团队设
export const getGroupDevs = (data) => {
    return $post("/user/getGroupDevs", data);
};

// 修改团队设备备注
export const updateGroupDevRemarks = (data) => {
    return $post("/user/updateGroupDevRemarks", data);
};

// 删除团队设备
export const deleteGroupDev = (data) => {
    return $post("/user/deleteGroupDev", data);
};

// 修改设备分组名
export const updateDevGroupName = (data) => {
    return $post("/user/updateDevGroupName", data);
};

// 删除分组
export const deleteDevGroup = (data) => {
    return $post("/user/deleteDevGroup", data);
};

// 添加分组
export const addDivideDevGroup = (data) => {
    return $post("/user/addDivideDevGroup", data);
};

// 批量删除设备
export const deleteGroupDevs = (data) => {
    return $post("/user/deleteGroupDevs", data);
};

// 批量移动设备
export const moveOutGroupDevs = (data) => {
    return $post("/user/moveOutGroupDevs", data);
};

// 查询团队的设备申请列表
export const devApplyList = (data) => {
    return $post("/user/queryGroupDevApplyList", data);
};

// 处理部署设备申请
export const dealApplication = (data) => {
    return $post("/user/approveAddingEquipment2Team", data);
};

// 2.3.27成员管理列表
export const accountInfo = (data) => {
    return $post("/user/querySubAccountInfo", data);
};

// 修改团队成员备注
export const updateGroupSunMemo = (data) => {
    return $post("/user/updateGroupSunMemo", data);
};

// 成员管理：添加子账号
export const addSubAccount = (data) => {
    return $post("/user/addSubAccount", data);
};
// 注销登录
export const userDelete = (data) => {
    return $post2("/account/delete", data);
};

// 账号注销发送邮件
export const sendEmailCode = (data) => {
    // return $post2("/email/sendCode", data);
    // return $post2("/email/delete", data);
    return $post2("/email/sendCode", data);
};
// 账号邮箱验证 没用了
export const emailValidate = (data) => {
    return $post2("/email/validate", data);
};
// 查询用户最后账单号
export const userLastOrderId = (data) => {
    return $post("/user/getUserLastOrderId", data);
};
// 恢复订阅
export const subscribe = (data) => {
    return $post2("/subscribe/reinstate", data);
};
// 取消订阅
export const unsubscribe = (data) => {
    return $post2("/subscribe/deactivate", data);
};

// 收集注销原因
export const logoutReason = (data) => {
    return $post3(
        "https://sn.aomeisoftware.com/api/v1/uninstall-feedback",
        data
    );
};

// 3.3.38 新建团队角色类型
export const createTeamRole = (data) => {
    return $post("/user/createTeamRoleType", data);
};

// 3.3.39删除团队角色类型
export const deleteTeamRole = (data) => {
    return $post("/user/deleteTeamRoleType", {
        type: 39,
        seq: 14,
        ...data,
    });
};

// 3.3.40查询团队角色类型列表
export const getTeamRoleList = (data) => {
    return $post("/user/queryTeamRoleTypeColumn", {
        type: 40,
        seq: 544,
        ...data,
    });
};

// 3.3.41获取隶属角色类型的分组列表
export const getRoleGroupList = (data) => {
    return $post("/user/getRolecontrollabledevicegroupinglist", {
        type: 40,
        seq: 544,
        ...data,
    });
};

// 3.3.42获取隶属角色类型的设备列表(带可控信息)
export const getRoleGoupDevList = (data) => {
    return $post("/user/getTeamEquipmentRecords", {
        type: 42,
        seq: 90,
        ...data,
    });
};

// 3.3.43保存角色设置
export const saveRoleSettings = (data) => {
    return $post("/user/saveCharacterSettings", {
        type: 43,
        seq: 14,
        ...data,
    });
};

// 3.3.44 查询团队的设备（携带控制信息）
export const queryTeamEquipment = (data) => {
    return $post("/user/queryTeamEquipment", {
        type: 44,
        seq: 544,
        ...data,
    });
};

// 3.3.45 改变团队账号角色角色类型
export const changeTeamAccountRoleType = (data) => {
    return $post("/user/changeTeamAccountRoleType", {
        type: 45,
        seq: 34,
        ...data,
    });
};

// 3.3.46 修改角色的名称
export const changeRoleName = (data) => {
    return $post("/user/changeRoleName", {
        type: 46,
        seq: 14,
        ...data,
    });
};
// 3.3.47 查询新申请设备个数
export const getNewApplied = (data) => {
    return $post("/user/queryNewlyAppliedDevicesNum", {
        type: 47,
        seq: 90,
        ...data,
    });
};

// export const emailValidate = (data) => {
//   return $post2("/email/validate", data);
// };

// menu数据
export const menu = (params) => {
    return $post("/menu", params).then((res) => {
        return res;
    });
};

// 设备列表数据
// export const deviceList = (params) => {
//   return $get("/device", params).then((res) => {
//     return res;
//   });
// };

// 用于从软件直接跳转过来的请求token
export const softLogin = (data) => {
    return $post2("/soft/login", {
        "cf-turnstile-response": "123",
        ...data,
    });
};